import React, { Component } from 'react';
import PropTypes from 'prop-types';
import VisibilitySensor from 'react-visibility-sensor';
import { triggerEdapEvent } from '../../utils/edap';
import { MODULE_VIEW_EVENT } from './events';

// An element invisible to the user but not to the browser
const invisibleElement = <div style={{ height: 1, marginTop: -1 }} />;

/**
 * Triggers an EDAP page.module.view event when its child is fully visible on the
 * client viewport.
 *
 * If no child is passed, an invisible element is used instead.
 */
class EdapModuleView extends Component {
  static propTypes = {
    eventOptions: PropTypes.shape({
      actionlocation: PropTypes.string
    }).isRequired,
    onModuleViewed: PropTypes.func,
    tagName: PropTypes.string,
    className: PropTypes.string
  };

  static defaultProps = {
    onModuleViewed: () => {},
    tagName: 'div',
    className: null
  };

  eventHasBeenTriggered = false;

  onVisibilityChange = (isVisible) => {
    if (!this.eventHasBeenTriggered && isVisible) {
      this.eventHasBeenTriggered = true;
      triggerEdapEvent(MODULE_VIEW_EVENT, this.props.eventOptions);
      this.props.onModuleViewed();
    }
  }

  render() {
    const { className, tagName: Tag } = this.props;
    const hasChildren = React.Children.count(this.props.children);
    return (
      <VisibilitySensor
        onChange={this.onVisibilityChange}
        active={!this.eventHasBeenTriggered}
        partialVisibility={'bottom'}
        delayedCall
      >
        {hasChildren ? <Tag className={className}>{this.props.children}</Tag> : invisibleElement}
      </VisibilitySensor>
    );
  }
}

export default EdapModuleView;
